import { render, staticRenderFns } from "./RemoteVideo.vue?vue&type=template&id=1a047214&scoped=true"
import script from "./RemoteVideo.vue?vue&type=script&lang=js"
export * from "./RemoteVideo.vue?vue&type=script&lang=js"
import style0 from "./RemoteVideo.vue?vue&type=style&index=0&id=1a047214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../Users/a0000/Documents/Box-IM/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a047214",
  null
  
)

export default component.exports